import { render, staticRenderFns } from "./Settings.html?vue&type=template&id=a8bd4852&scoped=true&"
import script from "./Settings.js?vue&type=script&lang=js&"
export * from "./Settings.js?vue&type=script&lang=js&"
import style0 from "./Settings.scss?vue&type=style&index=0&id=a8bd4852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bd4852",
  null
  
)

export default component.exports